import { Select } from '@99designs/common/components/Select';
import { getComponentClasses } from '@99designs/common/utils/app/index';
import classNames from 'classnames';
import moment, { Moment } from 'moment'; // tslint:disable-line:import-blacklist
import * as React from 'react';
import { SingleDatePicker } from 'react-dates';
import 'react-dates/initialize';

interface Props {
    onChange: (date: string) => void;
    value: string;
    disabled?: boolean;
    variations?: string[];
    error: boolean;
    name: string;
}

interface State {
    date: string | null;
    time: string | undefined;
    focused: boolean | null;
    disabled: boolean;
}

export default class DateTimePicker extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        const dateTime = this.props.value !== '' ? moment(this.props.value) : null;

        this.state = {
            time:
                dateTime !== null
                    ? '' + this.prependZeroToSingleCharStrings(dateTime.hour().toString())
                    : undefined,
            date: dateTime !== null ? dateTime.startOf('day').format('YYYY-MM-DD') : null,
            focused: false,
            disabled: false,
        };

        this.onDateChange = this.onDateChange.bind(this);
    }

    render() {
        const classes = classNames(getComponentClasses('date-time-picker', this.props.variations), {
            'date-time-picker--error': this.props.error,
        });

        return (
            <div className={classes} data-name={this.props.name}>
                <SingleDatePicker
                    placeholder={'Select date'}
                    disabled={this.props.disabled}
                    date={this.createDate(this.state.date)}
                    onDateChange={this.onDateChange}
                    focused={this.state.focused || false}
                    onFocusChange={({ focused }) => this.setState({ focused: focused })}
                    numberOfMonths={1}
                    isOutsideRange={this.isBeforeNextWeek}
                    id={this.generateId()}
                />
                <Select
                    variations={this.timeFieldVariations()}
                    name="time"
                    options={this.timeOptions()}
                    onChange={({ value }) => this.onTimeChange(value)}
                    value={this.state.time}
                />
            </div>
        );
    }

    createDate(date: string | null) {
        if (date === null) {
            return null;
        }

        return moment(date);
    }

    timeFieldVariations() {
        if (this.props.disabled || this.state.date === null) {
            return ['disabled'];
        }

        return [];
    }

    onDateChange(date: moment.Moment | null) {
        if (date === null) {
            return null;
        }

        const dateString = date.startOf('day').format('YYYY-MM-DD');
        this.setState({ date: dateString }, () => {
            this.invokeDateTimeChangedCallback();
        });
    }

    onTimeChange(time: string) {
        this.setState({ time }, () => {
            this.invokeDateTimeChangedCallback();
        });
    }

    invokeDateTimeChangedCallback() {
        if (this.state.date === null || this.state.time === undefined) {
            return;
        }

        const dateTime = moment(`${this.state.date} ${this.state.time}:00:00`);
        this.props.onChange(dateTime.format('YYYY-MM-DD HH:mm:ss'));
    }

    generateId() {
        return `date-picker-${Math.random().toString(36)}`;
    }

    prependZeroToSingleCharStrings(value: string) {
        return ('0' + value).slice(-2);
    }

    isBeforeNextWeek(day: Moment): boolean {
        const now = moment();
        const duration = moment.duration(day.diff(now));
        return duration.as('days') < 7;
    }

    timeOptions() {
        return [
            { label: 'Select time', value: '', disabled: true },
            { label: '12:00AM', value: '00' },
            { label: '1:00AM', value: '01' },
            { label: '2:00AM', value: '02' },
            { label: '3:00AM', value: '03' },
            { label: '4:00AM', value: '04' },
            { label: '5:00AM', value: '05' },
            { label: '6:00AM', value: '06' },
            { label: '7:00AM', value: '07' },
            { label: '8:00AM', value: '08' },
            { label: '9:00AM', value: '09' },
            { label: '10:00AM', value: '10' },
            { label: '11:00AM', value: '11' },
            { label: '12:00PM', value: '12' },
            { label: '1:00PM', value: '13' },
            { label: '2:00PM', value: '14' },
            { label: '3:00PM', value: '15' },
            { label: '4:00PM', value: '16' },
            { label: '5:00PM', value: '17' },
            { label: '6:00PM', value: '18' },
            { label: '7:00PM', value: '19' },
            { label: '8:00PM', value: '20' },
            { label: '9:00PM', value: '21' },
            { label: '10:00PM', value: '22' },
            { label: '11:00PM', value: '23' },
        ];
    }
}
